import * as types from './constants';

export function setSettings(data) {
  return { type: types.SET, data };
}
